export type SceneLayout = "2x2" | "4x4" | "6x6" | "auto";
export type FixedSceneLayout = Exclude<SceneLayout, "auto">;

export const FIXED_SCENE_LAYOUTS = ["2x2", "4x4", "6x6"] as const satisfies FixedSceneLayout[];

export const SCENE_LAYOUTS: SceneLayout[] = [...FIXED_SCENE_LAYOUTS, "auto"];

export const FIXED_LAYOUT_GRID: Record<FixedSceneLayout, { columns: number; rows: number }> = {
  "2x2": { columns: 2, rows: 2 },
  "4x4": { columns: 4, rows: 4 },
  "6x6": { columns: 6, rows: 6 },
};

const gridSlots = (layout: FixedSceneLayout) =>
  FIXED_LAYOUT_GRID[layout].columns * FIXED_LAYOUT_GRID[layout].rows;

export const SCENE_LAYOUT_LABEL: Record<SceneLayout, string> = {
  "2x2": "2×2",
  "4x4": "4×4",
  "6x6": "6×6",
  auto: "화면 맞춤",
};

export const SLOT_COUNT: Record<SceneLayout, number> = {
  "2x2": gridSlots("2x2"),
  "4x4": gridSlots("4x4"),
  "6x6": gridSlots("6x6"),
  auto: gridSlots("6x6"),
};

export interface SceneSlot {
  index: number;
  cctvId: number;
}

export interface CctvScene {
  id: string;
  name: string;
  layout: SceneLayout;
  slots: SceneSlot[];
  order: number;
  updatedAt: string;
}
